import React, { useEffect } from "react";
import { Browser } from "@syncfusion/ej2-base";
import { updateSampleSection } from "./Sample-base";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  AccumulationLegend,
  PieSeries,
  AccumulationTooltip,
  AccumulationDataLabel,
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Legend,
  Category,
  StackingColumnSeries,
  Tooltip,
  Highlight,
} from "@syncfusion/ej2-react-charts";

//#region Pie Chart
export let data1 = Browser.isDevice
  ? [
      { x: "Chrome", y: 59.28, text: "Chrome: 59.28%" },
      {
        x: "Safari",
        y: 4.73,
        text: Browser.isDevice ? "Safari <br> 4.73%" : "Safari: 4.73%",
      },
      { x: "Opera", y: 6.12, text: "Opera: 6.12%" },
      { x: "Edge", y: 7.48, text: "Edge: 7.48%" },
      { x: "Others", y: 22.39, text: "Others: 22.39%" },
    ]
  : [
      { x: "Chrome", y: 59.28, text: "Chrome: 59.28%" },
      { x: "UC Browser", y: 4.37, text: "UC Browser: 4.37%" },
      { x: "Opera", y: 3.12, text: "Opera: 3.12%" },
      { x: "Sogou Explorer", y: 1.73, text: "Sogou Explorer: 1.73%" },
      { x: "QQ", y: 3.96, text: "QQ: 3.96%" },
      { x: "Safari", y: 4.73, text: "Safari: 4.73%" },
      { x: "Internet Explorer", y: 6.12, text: "Internet Explorer: 6.12%" },
      { x: "Edge", y: 7.48, text: "Edge: 7.48%" },
      { x: "Others", y: 9.57, text: "Others: 9.57%" },
    ];
const SAMPLE_CSS = `
    .control-fluid {
        padding: 0px !important;
    }
    .pie-chart {
        align :center
    }`;

//#endregion

export let dataX1 = [
  { x: "2013", y: 9628912 },
  { x: "2014", y: 9609326 },
  { x: "2015", y: 7485587 },
  { x: "2016", y: 7793066 },
  { x: "2017", y: 6856880 },
];
export let dataX2 = [
  { x: "2013", y: 4298390 },
  { x: "2014", y: 4513769 },
  { x: "2015", y: 4543838 },
  { x: "2016", y: 4999266 },
  { x: "2017", y: 5235842 },
];
export let dataX3 = [
  { x: "2013", y: 2842133 },
  { x: "2014", y: 3016710 },
  { x: "2015", y: 3034081 },
  { x: "2016", y: 2945295 },
  { x: "2017", y: 3302336 },
];
export let dataX4 = [
  { x: "2013", y: 2006366 },
  { x: "2014", y: 2165566 },
  { x: "2015", y: 2279503 },
  { x: "2016", y: 2359756 },
  { x: "2017", y: 2505741 },
];
const SAMPLE_CSS2 = `
      .control-fluid {
          padding: 0px !important;
      }`;








function Pos_Graph() {
  useEffect(() => {
    updateSampleSection();
  }, []);

  const onChartLoad = (args) => {
    document.getElementById("pie-chart").setAttribute("title", "");
  };

  const onChartLoad2 = (args) => {
    let chart = document.getElementById('chartXs');
    chart.setAttribute('title', '');
};

  const load = (args) => {
    //let selectedTheme = location.hash.split('/')[1];
    let selectedTheme = window.location.hash.split("/")[1];

    selectedTheme = selectedTheme ? selectedTheme : "Material";

    args.accumulation.theme = (
      selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
    )
      .replace(/-dark/i, "Dark")
      .replace(/light/i, "Light")
      .replace(/contrast/i, "Contrast");

   
  };

  const load2 = (args) => {
    let selectedTheme = window.location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Material';
    args.chart.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark").replace(/contrast/i, 'Contrast');
};

  const axisLabelRender = (args) => {
    args.text = args.text.replace("0000000", "0M").replace("000000", "M");
  };

  return (
    <>
      





      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 text-center">
              <div className="col-sm-12">
                <h1 className="m-0">
                  {" "}
                  <i className="fas fa-tachometer-alt"> </i> Dashboard
                </h1>
              </div>
              {/* /.col */}
              {/*<div class="col-sm-6">
                      <ol class="breadcrumb float-sm-right">
                          <li class="breadcrumb-item"><a href="#!">Home</a></li>
                          <li class="breadcrumb-item active">Dashboard v1</li>
                      </ol>
                  </div>*/}
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            {/* Main row */}
            <div className="row">
              {/* Left col */}
              <section className="col-lg-12 connectedSortable">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title text-bold">
                      Project name 1{" "}
                      <span className="text-normal text-muted">
                        (Customer name)
                      </span>
                    </h5>
                    <div className="card-tools">
                      <a
                        href="#!"
                        className="text-white"
                        data-toggle="tooltip"
                        title="Needs to Review"
                      >
                        <span className="badge bg-ToReview">
                          <span className="text-biger">38</span>{" "}
                        </span>
                      </a>
                      <a
                        href="#!"
                        className="text-white"
                        data-toggle="tooltip"
                        title="Needs to Approve"
                      >
                        <span className="badge bg-ToApprove">49 </span>
                      </a>
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-tool "
                        data-card-widget="collapse"
                        data-toggle="tooltip"
                        title="Click for edit project"
                      >
                        <i className="fas fa-pencil-alt fa-lg" /> Edit
                      </button>
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="collapse"
                      >
                        <i className="fas fa-minus" />
                      </button>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div
                    className="card-body"
                    style={{ padding: "1rem 1rem 0rem 1rem" }}
                  >
                    <div className="row">
                      <div className="col-md-2">
                        <div className="d-md-flex">
                          <div
                            className="p-1 flex-fill"
                            style={{ overflow: "hidden" }}
                          >
                            {/* Map will be created here */}
                            <div id="world-map-markers">
                              <div className="invoice-col">
                                <div className="text-bold">Customer name</div>
                                <span className="text-small">
                                  <b>Year:</b> 2023
                                  <br />
                                  <b>Type:</b> XXXXXXXX
                                  <br />
                                  <b>Project start:</b> 01/03/2023
                                  <br />
                                  <b>Project end:</b> 01/03/2024
                                  <br />
                                  <b>Timesheet start:</b> 12/03/2023 <br />
                                  <b>Status:</b>{" "}
                                  <span className="badge bg-success">open</span>
                                  <br />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /.d-md-flex */}
                        <div className="dropdown-divider" />
                        <div className="progress-group">
                          <i className="fas fa-cubes" />{" "}
                          <span className="text-small">Department</span>
                          <span className="float-right">
                            <b>3</b>/5
                          </span>
                          <div className="progress progress-sm">
                            <div
                              className="progress-bar bg-primary"
                              style={{ width: "60%" }}
                            />
                          </div>
                        </div>
                        {/* /.progress-group */}
                        <div className="progress-group">
                          <i className="fas fa-users" />{" "}
                          <span className="text-small">Staffs</span>
                          <span className="float-right">
                            <b>7</b>/20
                          </span>
                          <div className="progress progress-sm">
                            <div
                              className="progress-bar bg-success"
                              style={{ width: "35%" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card direct-chat direct-chat-warning">
                          <div className="card-header">
                            <h3 className="card-title">
                              {" "}
                              <i className="fas fa-sitemap" /> Organization
                            </h3>
                            <div className="card-tools">
                              <div className="btn-group">
                                <button
                                  type="button"
                                  className="btn btn-tool dropdown-toggle"
                                  data-toggle="dropdown"
                                >
                                  <i className="fas fa-filter" />
                                </button>
                                <div
                                  className="dropdown-menu dropdown-menu-right"
                                  role="menu"
                                >
                                  <a href="#!" className="dropdown-item">
                                    -All-
                                  </a>
                                  <a href="#!" className="dropdown-item active">
                                    Department 1
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 2
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 3
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 4
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 5
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="control-pane">
                              <style>{SAMPLE_CSS}</style>
                              <div className="control-section row">
                                <AccumulationChartComponent
                                  id="pie-chart"
                                  title="Browser Market Share"
                                  load={load.bind(this)}
                                  legendSettings={{ visible: false }}
                                  enableSmartLabels={true}
                                  enableAnimation={false}
                                  center={{ x: "50%", y: "50%" }}
                                  enableBorderOnMouseMove={false}
                                  tooltip={{
                                    enable: true,
                                    format:
                                      // eslint-disable-next-line
                                      "<b>${point.x}</b><br>Browser Share: <b>${point.y}%</b>",
                                    header: "",
                                  }}
                                  loaded={onChartLoad.bind(this)}
                                >
                                  <Inject
                                    services={[
                                      AccumulationLegend,
                                      PieSeries,
                                      AccumulationTooltip,
                                      AccumulationDataLabel,
                                    ]}
                                  />
                                  <AccumulationSeriesCollectionDirective>
                                    <AccumulationSeriesDirective
                                      dataSource={data1}
                                      name="Browser"
                                      xName="x"
                                      yName="y"
                                      explode={true}
                                      explodeOffset="10%"
                                      explodeIndex={0}
                                      startAngle={Browser.isDevice ? 55 : 35}
                                      dataLabel={{
                                        visible: true,
                                        position: "Outside",
                                        name: "text",
                                        font: { fontWeight: "600" },
                                        connectorStyle: {
                                          length: "20px",
                                          type: "Curve",
                                        },
                                      }}
                                      radius={Browser.isDevice ? "40%" : "70%"}
                                    />
                                  </AccumulationSeriesCollectionDirective>
                                </AccumulationChartComponent>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-12 ">
                          <div className="control-pane">
        <style>{SAMPLE_CSS2}</style>
        <div className="control-section">
          <ChartComponent
            id="chartXs"
            style={{ textAlign: "center" }}
            legendSettings={{ enableHighlight: true }}
            primaryXAxis={{
              majorGridLines: { width: 0 },
              minorGridLines: { width: 0 },
              majorTickLines: { width: 0 },
              minorTickLines: { width: 0 },
              interval: 1,
              lineStyle: { width: 0 },
              labelIntersectAction: "Rotate45",
              valueType: "Category",
            }}
            primaryYAxis={{
              title: "Vehicles Production (In Millions)",
              lineStyle: { width: 0 },
              majorTickLines: { width: 0 },
              majorGridLines: { width: 1 },
              minorGridLines: { width: 1 },
              minorTickLines: { width: 0 },
              labelFormat: "{value}",
            }}
            width={Browser.isDevice ? "100%" : "75%"}
            chartArea={{ border: { width: 0 } }}
            load={load2.bind(this)}
            title="Motor Vehicle Production by Manufacturer"
            loaded={ onChartLoad2.bind(this)}
            tooltip={{ enable: true }}
            axisLabelRender={axisLabelRender.bind(this)}
          >
            <Inject
              services={[
                StackingColumnSeries,
                Category,
                Legend,
                Tooltip,
                Highlight,
              ]}
            />
            <SeriesCollectionDirective>
              <SeriesDirective
                dataSource={dataX1}
                xName="x"
                yName="y"
                name="General Motors"
                columnWidth={0.6}
                border={{ width: 1, color: "white" }}
                type="StackingColumn"
              />
              <SeriesDirective
                dataSource={[
                  { x: "2013", y: 4298390 },
                  { x: "2014", y: 4513769 },
                  { x: "2015", y: 4543838 },
                  { x: "2016", y: 4999266 },
                  { x: "2017", y: 5235842 },
                ]}
                xName="x"
                yName="y"
                name="Honda"
                columnWidth={0.6}
                border={{ width: 1, color: "white" }}
                type="StackingColumn"
              />
              <SeriesDirective
                dataSource={dataX3}
                xName="x"
                yName="y"
                name="Suzuki"
                columnWidth={0.6}
                border={{ width: 1, color: "white" }}
                type="StackingColumn"
              />
              <SeriesDirective
                dataSource={dataX4}
                xName="x"
                yName="y"
                name="BMW"
                columnWidth={0.6}
                border={{ width: 1, color: "white" }}
                type="StackingColumn"
              />
            </SeriesCollectionDirective>
          </ChartComponent>
          <div style={{ float: "right", marginRight: "10px" }}>
            Source: &nbsp;{" "}
            <a
              href="https://www.cyberagent.co.jp/en/newsinfo/press/detail/id=12026"
              target="_blank"
              rel="noreferrer"
            >
              www.cyberagent.co.jp
            </a>
          </div>
        </div>
      </div>
                            {/* /.card-pane-right */}
                          </div>
                          
                        </div>
                      </div>
                      {/* /.col */}
                    </div>
                    {/* /.row */}
                  </div>
                  {/* ./card-body */}
                  <div className="card-footer">
                    <div className="row">
                      {/* /.col */}
                      <div className="col-sm-3 col-6">
                        <div className="description-block border-right">
                          {/*<span class="description-percentage text-warning"><i class="fas fa-caret-left"></i> 0%</span>*/}
                          <h5 className="description-header">
                            <i className="fas fa-tasks text-muted " /> 390
                          </h5>
                          <span className="description-text">TOTAL TASK</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-3 col-6">
                        <div className="description-block border-right">
                          {/*<span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 20%</span>*/}
                          <h5 className="description-header">
                            <i className="fas fa-clock text-muted" /> 120d 5h
                            30m
                          </h5>
                          <span className="description-text">TOTAL TIME</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-3 col-6">
                        <div className="description-block border-right">
                          {/*<span class="description-percentage text-danger"><i class="fas fa-caret-down"></i> 18%</span>*/}
                          <h5 className="description-header">1200</h5>
                          <span className="description-text">XXXXXX</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      <div className="col-sm-3 col-6">
                        <div className="description-block ">
                          {/*<span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 17%</span>*/}
                          <h5 className="description-header">
                            <i className="fab fa-btc text-muted" /> 35,210.43{" "}
                          </h5>
                          <span className="description-text">OVERALL COST</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                    </div>
                    {/* /.row */}
                  </div>
                  {/* /.card-footer */}
                </div>
                {/* /.card */}
                {/* /.card 2  */}
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title text-bold">
                      Project name 2{" "}
                      <span className="text-normal text-muted">
                        (Customer name2)
                      </span>
                    </h5>
                    <div className="card-tools">
                      <a
                        href="#!"
                        className="text-white"
                        data-toggle="tooltip"
                        title="Needs to Review"
                      >
                        <span className="badge bg-ToReview">
                          <span className="text-biger">21</span>{" "}
                        </span>
                      </a>
                      <a
                        href="#!"
                        className="text-white"
                        data-toggle="tooltip"
                        title="Needs to Approve"
                      >
                        <span className="badge bg-ToApprove">67 </span>
                      </a>
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-tool"
                        data-card-widget="collapse"
                        data-toggle="tooltip"
                        title="Click for edit project"
                      >
                        <i className="fas fa-pencil-alt fa-lg" /> Edit
                      </button>
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="collapse"
                      >
                        <i className="fas fa-minus" />
                      </button>
                      {/*<div class="btn-group">
          <button type="button" class="btn btn-tool dropdown-toggle" data-toggle="dropdown">
              <i class="fas fa-search"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" role="menu">
              <a href="#!" class="dropdown-item">Project Info.</a>
              <a href="#!" class="dropdown-item">Project Organization</a>
              <a href="#!" class="dropdown-item">Project Time</a>
              <div class="dropdown-divider"></div>
              <a href="#!" class="dropdown-item">Project ....</a>
          </div>
      </div>*/}
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div
                    className="card-body"
                    style={{ padding: "1rem 1rem 0rem 1rem" }}
                  >
                    <div className="row">
                      <div className="col-md-2">
                        <div className="d-md-flex">
                          <div
                            className="p-1 flex-fill"
                            style={{ overflow: "hidden" }}
                          >
                            {/* Map will be created here */}
                            <div id="world-map-markers">
                              <div className="invoice-col">
                                <div className="text-bold">Customer name</div>
                                <span className="text-small">
                                  <b>Year:</b> 2023
                                  <br />
                                  <b>Type:</b> XXXXXXXX
                                  <br />
                                  <b>Project start:</b> 01/03/2023
                                  <br />
                                  <b>Project end:</b> 01/03/2024
                                  <br />
                                  <b>Timesheet start:</b> 12/03/2023 <br />
                                  <b>Status:</b>{" "}
                                  <span className="badge bg-success">open</span>
                                  <br />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /.d-md-flex */}
                        <div className="dropdown-divider" />
                        <div className="progress-group">
                          <i className="fas fa-cubes" />{" "}
                          <span className="text-small">Department</span>
                          <span className="float-right">
                            <b>3</b>/5
                          </span>
                          <div className="progress progress-sm">
                            <div
                              className="progress-bar bg-primary"
                              style={{ width: "60%" }}
                            />
                          </div>
                        </div>
                        {/* /.progress-group */}
                        <div className="progress-group">
                          <i className="fas fa-users" />{" "}
                          <span className="text-small">Staffs</span>
                          <span className="float-right">
                            <b>7</b>/20
                          </span>
                          <div className="progress progress-sm">
                            <div
                              className="progress-bar bg-success"
                              style={{ width: "35%" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card direct-chat direct-chat-warning">
                          <div className="card-header">
                            <h3 className="card-title">
                              {" "}
                              <i className="fas fa-sitemap" /> Organization
                            </h3>
                            <div className="card-tools">
                              {/*<select class="form-control form-control-sm" style="width: 30%;">
                          <option selected="">-All-</option>
                          <option>Departmentxxxxxxx 1</option>
                          <option>Department 2</option>
                          <option>Department 3</option>
                          <option>Department 4</option>
                          <option>Department 5</option>
                      </select>*/}
                              <div className="btn-group">
                                <button
                                  type="button"
                                  className="btn btn-tool dropdown-toggle"
                                  data-toggle="dropdown"
                                >
                                  <i className="fas fa-filter" />
                                </button>
                                <div
                                  className="dropdown-menu dropdown-menu-right"
                                  role="menu"
                                >
                                  <a href="#!" className="dropdown-item">
                                    -All-
                                  </a>
                                  <a href="#!" className="dropdown-item active">
                                    Department 1
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 2
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 3
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 4
                                  </a>
                                  <a href="#!" className="dropdown-item">
                                    Department 5
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="direct-chat-messages">
                              <ul className="users-list clearfix">
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S1</i>
                                  </div>
                                  <a
                                    className="users-list-name"
                                    href="#!"
                                    title="Sarah Bullock"
                                  >
                                    Sarah Bullock
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S2</i>
                                  </div>
                                  <a
                                    className="users-list-name"
                                    href="#!"
                                    title="Alexander Pierce"
                                  >
                                    Alexander Pierce
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a
                                    className="users-list-name"
                                    href="#!"
                                    title="Charles Malkins"
                                  >
                                    Charles Malkins
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a
                                    className="users-list-name"
                                    href="#!"
                                    title="Creed Bratton"
                                  >
                                    Creed Bratton
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a
                                    className="users-list-name"
                                    href="#!"
                                    title="Sarah Bullock"
                                  >
                                    staff 3
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a className="users-list-name" href="#!">
                                    staff 3
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a className="users-list-name" href="#!">
                                    staff 3
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a className="users-list-name" href="#!">
                                    staff 3
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                <li>
                                  <div
                                    style={{ display: "inline-block" }}
                                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                  >
                                    <i className="fa"> S3</i>
                                  </div>
                                  <a className="users-list-name" href="#!">
                                    staff 3
                                  </a>
                                  <span className="users-list-date">
                                    position
                                  </span>
                                </li>
                                {/*<li>
                              <div style="display:inline-block;" class="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"><i class="fa"> S3</i></div>
                              <a class="users-list-name" href="#!">staff 3</a>
                              <span class="users-list-date">position</span>
                          </li>
                          <li>
                              <div style="display:inline-block;" class="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"><i class="fa"> S3</i></div>
                              <a class="users-list-name" href="#!">staff 3</a>
                              <span class="users-list-date">position</span>
                          </li>
                          <li>
                              <div style="display:inline-block;" class="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"><i class="fa"> S3</i></div>
                              <a class="users-list-name" href="#!">staff 3</a>
                              <span class="users-list-date">position</span>
                          </li>*/}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-4 ">
                            <div className="card-pane-left bg-light pt-2 pb-2 pl-4 pr-4 card">
                              <div className="description-block mb-4 bg-gray-dark">
                                <div className="sparkbar pad" data-color="#fff">
                                  Work time
                                </div>
                                {/*<span class="description-text">Work time</span>*/}
                              </div>
                              {/* /.description-block */}
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fas fa-clock text-muted text-smaller" />{" "}
                                  12d 5h 30m
                                </h5>
                              </div>
                              {/* /.description-block */}
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fas fa-user text-muted text-smaller" />{" "}
                                  2{" "}
                                  <span className="text-muted text-small text-normal">
                                    (staffs)
                                  </span>
                                </h5>
                              </div>
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fab fa-btc text-muted text-smaller" />
                                  12,000.50{" "}
                                  <span className="text-muted text-small text-normal">
                                    (cost)
                                  </span>
                                </h5>
                              </div>
                              <div className="description-block mb-4 bg-gray ">
                                <h5 className="description-header">xxx %</h5>
                              </div>
                              {/* /.description-block */}
                            </div>
                            {/* /.card-pane-right */}
                          </div>
                          <div className="col-md-4">
                            <div className="card-pane-left bg-light pt-2 pb-2 pl-4 pr-4 card">
                              <div className="description-block mb-4 bg-gray-dark">
                                <div className="sparkbar pad" data-color="#fff">
                                  Over time
                                </div>
                              </div>
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fas fa-clock text-muted text-smaller" />{" "}
                                  12d 5h 30m{" "}
                                  <span className="text-muted text-small text-normal">
                                    (12%)
                                  </span>
                                </h5>
                              </div>
                              {/* /.description-block */}
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fas fa-user text-muted text-smaller" />{" "}
                                  1{" "}
                                  <span className="text-muted text-small text-normal">
                                    (staffs)
                                  </span>
                                </h5>
                              </div>
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fab fa-btc text-muted text-smaller" />
                                  2,000.50{" "}
                                  <span className="text-muted text-small text-normal">
                                    (cost)
                                  </span>
                                </h5>
                              </div>
                              <div className="description-block mb-4 bg-gray ">
                                <h5 className="description-header">xxx %</h5>
                              </div>
                              {/* /.description-block */}
                            </div>
                            {/* /.card-pane-right */}
                          </div>
                          <div className="col-md-4">
                            <div className="card-pane-left bg-light pt-2 pb-2 pl-4 pr-4 card">
                              <div className="description-block mb-4 bg-gray-dark">
                                <div className="sparkbar pad" data-color="#fff">
                                  Expenses
                                </div>
                              </div>
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fab fa-btc text-muted text-smaller" />
                                  195,300
                                  <span className="text-muted text-small text-normal">
                                    (Extra)
                                  </span>
                                </h5>
                              </div>
                              {/* /.description-block */}
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fab fa-btc text-muted text-smaller" />
                                  22,700
                                  <span className="text-muted text-small text-normal">
                                    (Travel)
                                  </span>
                                </h5>
                              </div>
                              <div className="description-block mb-4">
                                <h5 className="description-header">
                                  <i className="fab fa-btc text-muted text-smaller" />
                                  14,500.50
                                  <span className="text-muted text-small text-normal">
                                    (Other)
                                  </span>
                                </h5>
                              </div>
                              <div className="description-block mb-4 bg-gray ">
                                <h5 className="description-header">xxx %</h5>
                              </div>
                              {/* /.description-block */}
                            </div>
                            {/* /.card-pane-right */}
                          </div>
                        </div>
                      </div>
                      {/* /.col */}
                    </div>
                    {/* /.row */}
                  </div>
                  {/* ./card-body */}
                  <div className="card-footer">
                    <div className="row">
                      {/* /.col */}
                      <div className="col-sm-3 col-6">
                        <div className="description-block border-right">
                          {/*<span class="description-percentage text-warning"><i class="fas fa-caret-left"></i> 0%</span>*/}
                          <h5 className="description-header">
                            <i className="fas fa-tasks text-muted " /> 390
                          </h5>
                          <span className="description-text">TOTAL TASK</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-3 col-6">
                        <div className="description-block border-right">
                          {/*<span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 20%</span>*/}
                          <h5 className="description-header">
                            <i className="fas fa-clock text-muted" /> 120d 5h
                            30m
                          </h5>
                          <span className="description-text">TOTAL TIME</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-3 col-6">
                        <div className="description-block border-right">
                          {/*<span class="description-percentage text-danger"><i class="fas fa-caret-down"></i> 18%</span>*/}
                          <h5 className="description-header">1200</h5>
                          <span className="description-text">XXXXXX</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      <div className="col-sm-3 col-6">
                        <div className="description-block ">
                          {/*<span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 17%</span>*/}
                          <h5 className="description-header">
                            <i className="fab fa-btc text-muted" /> 35,210.43{" "}
                          </h5>
                          <span className="description-text">OVERALL COST</span>
                        </div>
                        {/* /.description-block */}
                      </div>
                    </div>
                    {/* /.row */}
                  </div>
                  {/* /.card-footer */}
                </div>
                {/* /.card */}
              </section>
              {/* /.Left col */}
            </div>
            {/* /.row (main row) */}
          </div>
          {/* /.container-fluid */}
        </section>
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default Pos_Graph;
